import { Component, Input, OnInit } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { DynamicOptionsComponent } from '../dynamic-options';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'automata-positive-integer',
  templateUrl: './positive-integer.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
  ],
})
export class PositiveIntegerComponent implements OnInit, DynamicOptionsComponent {
  numberInputControl: FormControl = new FormControl(null, [Validators.required, Validators.min(0)]);
  selectedValue$ = this.numberInputControl.valueChanges;

  @Input() initialValue = 0;

  ngOnInit(): void {
    if (typeof this.initialValue !== 'number') {
      this.initialValue = 0;
    }

    this.numberInputControl.setValue(this.initialValue);
  }

  getSelectedValue(): number {
    return this.numberInputControl.value;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.numberInputControl];
  }

  isFormValid(): boolean {
    return this.numberInputControl.valid;
  }
}
